export default "__VITE_ASSET__DPkv74uA__"